import React,{useState} from 'react'
import "./Login.css"
import { useDispatch } from 'react-redux'
import { Userlogin } from "../../features/User/UserAction"
import {  useNavigate } from 'react-router-dom'



export default function Login({ setSignIn }) { 
    const [success, setSuccess] = useState(true)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [FormData, setFormData] = useState({
        email: "",
        password: "",
    })
    const handleChange = (e) => { 
        setFormData({
            ...FormData, [e.target.name]: e.target.value
        })  
    }
    const handleSubmit = (e) => { 
        e.preventDefault()
        console.log(FormData)
        dispatch(Userlogin(FormData)).unwrap()
        .then((originalPromiseResult) => {
            navigate("/home")
        })
        .catch((rejectedValueOrSerializedError) => {
            setSuccess(false)
            alert("Wrong Credentials")
            console.log(rejectedValueOrSerializedError)
        })
    }
    
    return (
      <div className='Login'>
          <div className="LoginContent">
              <strong> <h1 className='loginHeading' >Welcome to Bookworm Store</h1></strong>
                <div className='ContentList' >
                 <span> <i className="fa-solid fa-dollar-sign"></i> Sell Your Old Books</span>
                 <span><i className="fa-solid fa-rectangle-ad"></i> Post a free add to maximise the reach</span> 
                <span> <i className="fa-solid fa-comments-dollar"></i> Used Books available at afforadable prices</span> 
              </div>
          </div>
          <div style={{boxShadow: success === "true"?"none":"0 10px 18px 0 rgba(255, 0, 0, 0.2), 0 16px 30px 0 rgba(255, 0, 0, 0.19)"}} className="LoginForm">
               <form className='login-form' onSubmit={handleSubmit} >
                    <div className='login-form-comp'>
                        <label className='login-form-label'>Email</label>
                        <div>
                            <input className='login-form-input' name='email' onChange={handleChange} value={FormData.email} placeholder='Email@gmail.com' type= "email" />
                        </div>
                    </div>
                    <div className='login-form-comp'>
                        <label onChange={handleChange} value={FormData.password} className='login-form-label'>Password</label>
                        <div>
                            <input className='login-form-input'name='password' value={FormData.password} onChange={handleChange} placeholder='Enter Password' type= "password" />
                        </div>
                    </div>
                     { 
                        success !== "true" && (<div className='signUp-form-comp'>
                            {  success === false ? <div className='errorDiv' > "!!!Wrong credentials"</div> : null }
                        </div>)
                    }
                    <div className ='signUp-form-btn'> 
                        <button type="submit" className="login-btn">Login</button>           
                        <button className='btn content-btn'  onClick={()=>setSignIn(false)} ><span > Dont have an account ? Sign Up</span></button>
                    </div>
                </form>
          </div>
    </div>
  )
}
